import { Attachment } from "./attachment";

export class SupplierEquipmentItem {
  standardId: number;
  equipmentStandardId: number;
  title: string;
  model: string;
  effectiveFrom?: string;
  obsoleteDate?: string;
  imageAttachment?: Attachment;
  categoryName?: string;
  equipmentTypeName?: string;

  constructor(obj?: any) {
    if (obj) {
      this.standardId = obj.standardId;
      this.equipmentStandardId = obj.equipmentStandardId;
      this.title = obj.title;
      this.model = obj.model;
      this.effectiveFrom = obj.effectiveFrom;
      this.obsoleteDate = obj.obsoleteDate;
      this.imageAttachment = obj.imageAttachment ? new Attachment(obj.imageAttachment) : null;
      this.categoryName = obj.categoryName;
      this.equipmentTypeName = obj.equipmentTypeName;
    }
  }
}

export class Supplier {
  id: number = 0;
  name: string;
  description: string;
  supplierLogoAttachment: Attachment = new Attachment();
  imageAttachmentContentAsBase64: string;
  countryId?: Array<number>;
  isGlobal: boolean;
  assignedMarkets: string[] = [];
  equipments: SupplierEquipmentItem[] = [];

  constructor(obj?: Supplier) {
    if (obj) {
      this.id = obj.id;
      this.name = obj.name;
      this.description = obj.description;
      this.supplierLogoAttachment = new Attachment(obj.supplierLogoAttachment);
      this.countryId = obj.countryId;
      this.isGlobal = obj.isGlobal;
      this.assignedMarkets = obj.assignedMarkets || [];
      this.equipments = obj.equipments ? obj.equipments.map(e => new SupplierEquipmentItem(e)) : [];
    }
  }
}
